// Create a limited colour palette to avoid overwhelming new users
// and to make colour checking easier.  These definitions cannot be
// moved to blocks.js, which is loaded later, since they are used in
// top-level definitions below.  Note that the hex digits a-f are
// lower-case.  This is assumed in comparisons below.
var Colours = {
  BLACK: '#000000',
  GREY: '#808080',
  KHAKI: '#c3b091',
  WHITE: '#ffffff',
  RED: '#ff0000',
  PINK: '#ff77ff',
  ORANGE: '#ffa000',
  YELLOW: '#ffff00',
  GREEN: '#228b22',
  BLUE: '#0000cd',
  AQUAMARINE: '#7fffd4',
  PLUM: '#843179',

  FROZEN1: '#d0fdfd',
  FROZEN2: '#d0fdd0',
  FROZEN3: '#d0d0fd',
  FROZEN4: '#e0e0e0',
  FROZEN5: '#ffffff',
  FROZEN6: '#e8e8e8',
  FROZEN7: '#bbd1e4',
  FROZEN8: '#fdd0fd',
  FROZEN9: '#aea4ff',
};

module.exports = Colours;
